import { PixKeyType } from './key-type.enum';

export class PixKey {
	codigo: string;
	favorito: boolean;
	tipoChave: PixKeyType;
	criadoEm: Date;
	dataPropriedade: Date;
	codigoRequisicao: string;

	// reividicacoes
	situacaoReividicacao: SituacaoReividicacao;
	tipoReividicacao: string;
	modeloReividicacao: string;
	sequencialReividicacao: number;
	cancelarReividicacao = false;
	dataResolucaoReividicacao: Date;
	paraConcluir = false;
	respostaConcluir = false;
}

export enum SituacaoReividicacao {
	ABERTA = 'ABERTA',
	AGUARDANDO_RESOLUCAO = 'AGUARDANDO_RESOLUCAO',
	CONFIRMADA = 'CONFIRMADA',
	CANCELADA = 'CANCELADA',
	COMPLETADA = 'COMPLETADA'
}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/key.model.ts